/* Curviva: carruseles, pestañas y diapositivas de las secciones cvx */
(function () {
  function initCarousel(root) {
    if (root.__cvx) return; root.__cvx = true;
    var track = root.querySelector('[data-cvx-track]');
    var bar = root.querySelector('[data-cvx-bar]');
    var prev = root.querySelector('[data-cvx-prev]');
    var next = root.querySelector('[data-cvx-next]');
    if (!track) return;
    function step() { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + 14 : track.clientWidth; }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var nav = root.querySelector('.cvx-car__nav');
      if (nav) nav.style.display = max > 4 ? '' : 'none';
      if (bar) {
        var w = Math.max(track.clientWidth / track.scrollWidth, .12) * 100;
        bar.style.width = w + '%';
        bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - w) : 0) + '%';
      }
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    root.__cvxUpdate = update;
    update();
    initThumbs(root, track);
  }

  // Miniaturas de expertas: cada una lleva a su ficha y marca la que está visible
  function initThumbs(root, track) {
    var thumbs = [].slice.call(root.querySelectorAll('[data-cvx-thumb]'));
    if (!thumbs.length) return;
    function left(i) { return track.children[i].offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0); }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { track.scrollTo({ left: left(i), behavior: 'smooth' }); });
    });
    track.addEventListener('scroll', function () {
      var best = 0, dist = Infinity;
      thumbs.forEach(function (t, i) { var d = Math.abs(left(i) - track.scrollLeft); if (d < dist) { dist = d; best = i; } });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    }, { passive: true });
  }

  function initTabs(root) {
    if (root.__cvxTabs) return; root.__cvxTabs = true;
    var tabs = [].slice.call(root.querySelectorAll('[data-cvx-tab]'));
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o) {
          var on = o === t;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          var p = root.querySelector('[data-cvx-panel="' + o.getAttribute('data-cvx-tab') + '"]');
          if (p) { p.hidden = !on; if (on) p.querySelectorAll('[data-cvx-car]').forEach(function (c) { if (c.__cvxUpdate) c.__cvxUpdate(); else initCarousel(c); }); }
        });
      });
    });
  }

  function initSlides(root) {
    if (root.__cvxSlides) return; root.__cvxSlides = true;
    var track = root.querySelector('[data-cvx-slides]');
    var dots = [].slice.call(root.querySelectorAll('[data-cvx-dot]'));
    if (!track) return;
    var n = track.children.length, cur = 0, timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10) * 1000;
    function go(i) { cur = (i + n) % n; track.scrollTo({ left: track.clientWidth * cur, behavior: 'smooth' }); }
    function mark() {
      cur = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
    }
    function play() { stop(); if (delay > 0 && n > 1) timer = setInterval(function () { go(cur + 1); }, delay); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var p = root.querySelector('[data-cvx-sprev]'), nx = root.querySelector('[data-cvx-snext]');
    if (p) p.addEventListener('click', function () { go(cur - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); play(); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', play, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    mark(); play();
  }

  function initVideos(root) {
    [].slice.call(root.querySelectorAll('[data-cvx-play]')).forEach(function (b) {
      if (b.__cvx) return; b.__cvx = true;
      var v = b.parentNode.querySelector('video');
      if (!v) return;
      function start() {
        document.querySelectorAll('.cvx video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () { b.hidden = false; });
      }
      b.addEventListener('click', start);
      v.addEventListener('click', function () { if (v.paused) start(); else v.pause(); });
      v.addEventListener('play', function () { b.hidden = true; v.classList.add('is-playing'); });
      v.addEventListener('pause', function () { b.hidden = false; v.classList.remove('is-playing'); });
    });
    // Reseñas largas: «Leer más» solo cuando el texto no cabe
    [].slice.call(root.querySelectorAll('[data-cvx-more]')).forEach(function (q) {
      if (q.__cvx) return; q.__cvx = true;
      if (q.scrollHeight <= q.clientHeight + 2) return;
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'cvx-rv__more';
      more.textContent = q.getAttribute('data-cvx-more');
      q.classList.add('has-more');
      q.parentNode.insertBefore(more, q.nextSibling);
      more.addEventListener('click', function () {
        var open = q.classList.toggle('is-open');
        more.textContent = q.getAttribute(open ? 'data-cvx-less' : 'data-cvx-more');
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-cvx-car]').forEach(initCarousel);
    scope.querySelectorAll('[data-cvx-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-cvx-slideshow]').forEach(initSlides);
    initVideos(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
